module.exports = __webpack_public_path__ + "img/cz.1d4cf2eb.svg";